const dateTimeFormats = Object.freeze({
  'de': {
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    },
    onlyWeekday: {
      weekday: 'short',
    },
    withWeekday: {
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    long: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }
  },
});

export default dateTimeFormats;
